import { useGetJobAsUser } from "@taxassist/api-client";

const POLLING_INTERVAL_MS = 10_000;
const MAX_POLLING_DURATION_MS = 15 * 60 * 1000;

function isInFlight(job: unknown): boolean {
  const j = job as { processingResults?: Array<{ artifactType?: string; fileName?: string; verification?: { pipelineStatus?: string } }> } | undefined;
  const binder = (j?.processingResults ?? []).find(
    (r) =>
      r.artifactType === "binder" ||
      (r.artifactType === "supporting_doc" && /\b(bookmark|binder)/i.test(r.fileName ?? "")),
  );
  const ps = binder?.verification?.pipelineStatus;
  return ps === "pending" || ps === "processing";
}

export function useBinderVerificationJob(
  firmId: string | null | undefined,
  jobId: string | null | undefined,
) {
  const startedAt = Date.now();
  return useGetJobAsUser(firmId ?? "", jobId ?? "", {
    query: {
      enabled: !!firmId && !!jobId,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      refetchInterval: (query: { state: { data?: unknown } }) => {
        if (Date.now() - startedAt > MAX_POLLING_DURATION_MS) return false;
        return isInFlight(query.state.data) ? POLLING_INTERVAL_MS : false;
      },
    },
  });
}
